/******************************************************************************
 * Created Date: Friday Mar 18 2022                                           *
 * Author: Patrick B.                                                         *
 * -----                                                                      *
 * Last Modified: Fri Mar 18 2022                                             *
 * Modified By: Patrick B.                                                    *
 * -----                                                                      *
 * File: /src/components/common/selects/PoiSelect.js                          *
 * Copyright (c) 2022 Kuva                                                    *
 ******************************************************************************/

import React from "react";
import {
  Select,
  FormControl,
  MenuItem,
  InputLabel,
  Tooltip,
  Typography
} from "@mui/material";
import PropTypes from "prop-types";

const PoiSelect = ({ pois, selectedPoi, setSelectedPoi, showTooltip }) => {
  const handleChange = event => {
    setSelectedPoi(event.target.value);
  };

  return (
    <FormControl
      variant="standard"
      style={{
        display: "flex",
        minWidth: "8ch"
      }}
    >
      <Tooltip title={showTooltip ? "Select POI" : ""} placement="left">
        <span>
          <InputLabel
            style={{
              fontSize: 14,
              width: "100%"
            }}
            id="select-poi-label"
          >
            <Typography variant="subtitle1">POI</Typography>
          </InputLabel>
          <Select
            variant="standard"
            style={{ width: "100%" }}
            id="select-poi"
            value={selectedPoi}
            label="POI"
            onChange={handleChange}
          >
            {pois.map(poi => {
              return (
                <MenuItem key={poi} value={poi}>
                  {poi}
                </MenuItem>
              );
            })}
          </Select>
        </span>
      </Tooltip>
    </FormControl>
  );
};

PoiSelect.propTypes = {
  pois: PropTypes.array.isRequired,
  selectedPoi: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired,
  setSelectedPoi: PropTypes.func.isRequired,
  showTooltip: PropTypes.bool
};

export default PoiSelect;
